import { breakpoints, Checkbox, Inline, type AlignTypes } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { useController, useFormContext } from 'react-hook-form';
import isEmpty from 'lodash/isEmpty';
import { DIRECT_FLIGHT } from '../constants/formFields';

const inlineStyle = css`
  @media (min-width: ${breakpoints._768}) {
    height: 48px;
  }
`;

const labelStyles = css`
  cursor: pointer;
  font-size: 0.875rem;
`;

interface DirectFlightCheckBoxProps {
  align?: AlignTypes;
}

const DirectFlightCheckBox = ({ align }: DirectFlightCheckBoxProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({ control, name: DIRECT_FLIGHT });

  return (
    <Inline align={align} alignY="center" className={inlineStyle} noWrap spacing={8}>
      <Checkbox
        checked={value}
        data-testid={`${DIRECT_FLIGHT}-input`}
        hasError={!isEmpty(error)}
        id="directFlightCheckbox"
        name={DIRECT_FLIGHT}
        onChange={onChange}
      />
      <label className={labelStyles} htmlFor="directFlightCheckbox">
        {t('Air.Search.DirectFlightsOnly')}
      </label>
    </Inline>
  );
};

export default DirectFlightCheckBox;
